import type { ReactNode } from 'react';
import CubeLogo from './CubeLogo';
import ConsentManager from './ConsentManager';
import { CONTACT_EMAIL } from '../lib/site';

export default function PageShell({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen bg-surface text-text-main font-sans selection:bg-primary selection:text-white overflow-x-hidden">
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[120] focus:bg-surface focus:text-text-main focus:px-4 focus:py-3 focus:text-sm focus:font-semibold"
      >
        Ga naar inhoud
      </a>
      <ConsentManager />

      <header className="flex items-center justify-between px-6 md:px-12 py-6 border-b border-secondary/20">
        <a href="/" aria-label="Project LEO, naar de homepage" className="block">
          <CubeLogo />
        </a>
        <a href="/" className="px-2 py-3 text-xs tracking-[0.3em] uppercase font-medium hover:text-primary transition-colors">
          &larr; Terug naar de website
        </a>
      </header>

      <main id="main" tabIndex={-1} className="px-6 md:px-12 focus:outline-none">
        {children}
      </main>

      <footer className="border-t border-secondary/20 px-6 md:px-12 py-10 text-xs tracking-widest uppercase text-secondary">
        <nav aria-label="Footermenu" className="flex flex-wrap gap-x-6 gap-y-1">
          <a href="/" className="px-2 py-3 hover:text-primary transition-colors">Home</a>
          <a href="/privacy" className="px-2 py-3 hover:text-primary transition-colors">Privacy</a>
          <a href="/disclaimer" className="px-2 py-3 hover:text-primary transition-colors">Disclaimer</a>
          <a href={`mailto:${CONTACT_EMAIL}`} className="px-2 py-3 normal-case tracking-normal hover:text-primary transition-colors">{CONTACT_EMAIL}</a>
        </nav>
        <p className="mt-6 normal-case tracking-normal">&copy; 2026, Blueprint Development.</p>
      </footer>
    </div>
  );
}
